<!-- Modal -->
<div id="exampleModal">
	<div>

		<!-- <ngx-loading [show]="loading"></ngx-loading> -->
		<div class="modal-content p-0">

			<div class="flex-column  mb-4">
				<button type="button" class="close right-0" aria-label="Close" (click)="close()">
					<span aria-hidden="true">&times;</span>
				</button>
				<div class="w-100 getinTouch mb-3" id="exampleModalLabel" *ngIf="!disableContactForm">Thanks for your interest
					in iDEC Solution</div>
				<p>To request a quote or want to learn more about all-in-one business solution platform? Submit this form and we
					will contact you soon.</p>
				<!-- <p class="d-flex justify-content-center"><img src="../../assets/images/mail.gif"
                    class="img-fluid " alt=""></p> -->
				<h5 class="modal-title getinTouch" id="exampleModalLabel" *ngIf="disableContactForm">Have a Question ?
				</h5>
			</div>
			<div class="modal-body px-0">
				<div [formGroup]="userForm" *ngIf="!disableContactForm">

					<div class="contact-responsive ">

						<div class="contact-inquiry-style flex1 d-flex flex-column align-items-center">
							<h6 class="inquirytype mb-5 underline left">What sort of inquiry do you need help with?</h6>
							<div>
								<label class=" ft-12">
									<mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
										name="selectedValue" [(ngModel)]="selectedValue" [ngModelOptions]="{standalone: true}"
										(change)="getChangedValue(selectedValue)">
										<mat-radio-button class="example-radio-button" *ngFor="let item of dropdownList" [value]="item">
											{{item}}
										</mat-radio-button>
										<ng-container *ngIf="submitted && formValues['inquiryType'].errors">
											<mat-error *ngIf="formValues['inquiryType'].errors?.['required']">
												<em class="fas fa-exclamation-circle mr-2"></em>Inquiry Type is required
											</mat-error>
										</ng-container>
									</mat-radio-group>
								</label>
							</div>
						</div>
						<div class="contact-address-style">
							<div>

								<mat-form-field>
									<mat-label>Name</mat-label>
									<input matInput formControlName="name">
									<ng-container *ngIf="submitted && formValues['name'].errors">
										<mat-error *ngIf="formValues['name'].errors?.['required']">
											<em class="fas fa-exclamation-circle mr-2"></em>Name is required
										</mat-error>
										<mat-error *ngIf="formValues['name'].errors?.['pattern']">
											<em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
										</mat-error>
									</ng-container>
								</mat-form-field>
							</div>
							<div>
								<app-contact-form formControlName="contact"></app-contact-form>
							</div>
							<div class="mb-10">

								<mat-form-field class="field">
									<mat-label>Company</mat-label>
									<input matInput formControlName="organization">
									<ng-container *ngIf="submitted && formValues['organization'].errors">
										<mat-error *ngIf="formValues['organization'].errors?.['required']">
											<em class="fas fa-exclamation-circle mr-2"></em>Company name is required
										</mat-error>
										<mat-error *ngIf="formValues['organization'].errors?.['pattern']">
											<em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
										</mat-error>
									</ng-container>
								</mat-form-field>
							</div>
							<div class="-text-area-field-height">
								<mat-form-field>
									<mat-label>Write your message</mat-label>
									<textarea matInput cdkTextareaAutosize formControlName="message" #autosize="cdkTextareaAutosize"
										cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>

			</div>


			<div class="btn-basket">
				<!-- <button mat-raised-button type="button"  color="primary" (click)="close()">Cancel</button> -->
				<button mat-raised-button *ngIf="!disableContactForm" type="button" class="px-3 py-1" color="primary"
					(click)="loginDemo()">Send Message</button>
			</div>
		</div>
	</div>
</div>